// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"social-module--social-icon--3ynku","socialWrapper":"social-module--social-wrapper--631PS"};